class ProgressBar extends HTMLElement {
  constructor() {
    super();
    this.currentText = this.querySelector('[data-progress-current]');
    this.progressLine = this.querySelector('[data-progress-line]');
    this.titleElement = this.querySelector('.progress-bar-title-js');
    this.maxText = this.querySelector('[data-progress-max]');

    this.max = parseFloat(this.getAttribute('max')) || parseFloat(this.maxText?.textContent) || 5;
    this.value = parseFloat(this.getAttribute('value')) || parseFloat(this.currentText?.textContent) || 0;

    this.counterElement = this.querySelector('.drawer__progress-counter');
    this.cartTotalCount = parseFloat(this.getAttribute('data-cart-total-count')) || 0;

    this.onCartUpdate = this.onCartUpdate.bind(this);
  }

  connectedCallback() {
    this.render();
    document.addEventListener('cart:updated', this.onCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:updated', this.onCartUpdate);
  }

  onCartUpdate(event) {
    const cart = event.detail?.cart;
    if (cart) {
      this.cartTotalCount = cart.item_count ?? (cart.items ? cart.items.length : 0);

      const samples = (cart.items || []).filter(item => {
        const sku = (item.sku || '').toUpperCase();
        return sku.includes('SAMPLE') || sku.includes('LARGE') || sku.includes('FULL');
      });
      const sampleQty = samples.reduce((sum, item) => sum + item.quantity, 0);
      this.value = sampleQty;

      this.setAttribute('value', this.value);
      this.render();
    }
  }

  render() {
    this.style.display = this.cartTotalCount === 0 ? 'none' : '';

    if (this.currentText) {
      this.currentText.textContent = Math.min(this.value, this.max);
    }

    if (this.maxText) {
      this.maxText.textContent = this.max;
    }

    const percentage = Math.min((this.value / this.max) * 100, 100);

    if (this.progressLine) {
      this.style.setProperty('--progress', `${percentage}%`);
    }

    if (this.titleElement) {
      const completeText = this.titleElement.getAttribute('data-complete-text');
      const incompleteText = this.titleElement.getAttribute('data-incomplete-text');

      if (this.value >= this.max && completeText) {
        this.titleElement.textContent = completeText;
      } else if (incompleteText) {
        this.titleElement.textContent = incompleteText;
      }
    }

    if (this.counterElement) {
      this.counterElement.style.display = this.value >= this.max ? 'none' : 'flex';
    }

    if (this.value >= this.max) {
      this.classList.add('is-complete');
    } else {
      this.classList.remove('is-complete');
    }
  }
}

if (!customElements.get('progress-bar')) {
  customElements.define('progress-bar', ProgressBar);
}